import EventService from '@common/event/EventService';
export const REMOVE_MODAL_EVENT_NAME = 'remove-from-dom';
export const unmountModalApp = (appId) => {
    const appContainer = document.getElementById(appId);
    if (!appContainer)
        return;
    EventService.dispatch(REMOVE_MODAL_EVENT_NAME, { target: appContainer });
};
